// extracted by mini-css-extract-plugin
module.exports = {"row":"BalanceByCurrency_row_QMvvl","relative":"BalanceByCurrency_relative_kQOp1"};